import camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';

import { deep } from './deep';

const keysToCamel = (obj) => mapKeys(obj, (value, key) => camelCase(key));

/**
 * Deeply converts all the object or array of object's keys to camelCase
 * @param {*} obj Object with keys to convert
 */
export const deepKeysToCamel = (obj) => deep(obj, keysToCamel);
